import { authenticatedFastApiAxiosInstanceAllowEmptyString } from "@/lib/data/http";
import { type APIResponse, type MatterSettlementDemand } from "@/lib/types";
import { baseFastApiMatterRoute } from "./matter";

const baseFastApiMatterSettlementDemandsRoute = `${baseFastApiMatterRoute}/settlement-demands`;

type MatterSettlementDemandWritePayload = Omit<
  Partial<MatterSettlementDemand>,
  "attorneyFeeAmount" | "connections"
>;

export type CreateMatterSettlementDemandInput =
  MatterSettlementDemandWritePayload;
export type UpdateMatterSettlementDemandInput = Pick<
  MatterSettlementDemand,
  "id" | "matterId" | "dateModified"
> &
  MatterSettlementDemandWritePayload;

const serializeMatterSettlementDemandWritePayload = (
  data: MatterSettlementDemandWritePayload,
) => {
  const payload = { ...data } as Partial<MatterSettlementDemand>;
  delete payload.attorneyFeeAmount;
  delete payload.connections;
  return payload;
};

export const createMatterSettlementDemandV1 = (
  data: CreateMatterSettlementDemandInput,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<MatterSettlementDemand>
    >(baseFastApiMatterSettlementDemandsRoute, serializeMatterSettlementDemandWritePayload(data))
    .then((res) => res.data);
};

export const deleteMatterSettlementDemandV1 = (
  data: Pick<MatterSettlementDemand, "id" | "matterId">,
) => {
  const { id } = data;

  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .delete<
      APIResponse<MatterSettlementDemand>
    >(`${baseFastApiMatterRoute}/settlement-demands/${id}`)
    .then((res) => res.data);
};

export const updateMatterSettlementDemandV1 = (
  data: UpdateMatterSettlementDemandInput,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MatterSettlementDemand>
    >(baseFastApiMatterSettlementDemandsRoute, serializeMatterSettlementDemandWritePayload(data))
    .then((res) => res.data);
};
